export class AppConstants {
    public static get baseUrl(): String {
        return "https://www.valobit.io/mobile/";
    };

    public static get etherScanApiKey(): String {
        return "5A25M1X6J981ZWCNE6FHGGIQ1MAYW6MYFH"
    }
}